import { Label, TextInput } from 'flowbite-react';
import React, { useState } from 'react';
import { LoginFormMeta, LoadingSpinnerMeta } from '../data'
import { Button, Card, LoadingSpinner, SplitBackgroundLayout } from '../components';
import { Link, useNavigate } from 'react-router-dom';


//const API_BASE_URL = `http://localhost:8000/api`;
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api';

function LoginForm() {
    const meta = LoginFormMeta
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)
    const [showResendVerification, setShowResendVerification] = useState(false)
    const [resendingVerification, setResendingVerification] = useState(false)
    const [resendMessage, setResendMessage] = useState<string | null>(null)
    const [approval, setApproval] = useState<string | boolean>(false);
    const [formData, setFormData] = useState({
        email: "",
        password: ""
    });
    const navigate = useNavigate();

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };


    const handleGetUserAuthApproval = async (id) => {
        try {
            const response = await fetch(API_BASE_URL + '/user/' + id, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                credentials: 'include'
            });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Request failed.');
            }
            const data = await response.json();
            console.log("Get Admin Rights Successful:", data);
            return data;

        } catch (err) {
            console.error('Get Admin Rights Failed:', err);
            setError(err.message || 'Failed to get user authorization.');
            return null;
        }
    }

    const ApprovalSettings = async (key) => {
        try {
            const response = await fetch(`${API_BASE_URL}/settings/key/${key}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                credentials: 'include'
            });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Request failed.');
            }
            const data = await response.json();
            setApproval(data.value);
            return data.value;

        } catch (err) {
            console.error('Settings check failed:', err);
            setApproval(false);
            return false;
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);
        setShowResendVerification(false); // Reset on each attempt

        const loginData = {
            email: formData.email,
            password: formData.password
        };

        try {
            const response = await fetch(API_BASE_URL + '/auth/login',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    credentials: 'include',
                    body: JSON.stringify(loginData)
                });

            const result = await response.json();

            if (!response.ok) {
                // Check if error is due to unverified email
                if (result.error_code === 'EMAIL_NOT_VERIFIED') {
                    setShowResendVerification(true)
                }

                throw new Error(result.message || 'Login failed.');
            }
            else {
                console.log('Reditecting to profile page');
                window.location.href = "/";
            }


            // const data = await response.json();
            // console.log('Login Successful:', data);
            // const [isApproved, userDetails] = await Promise.all([
            //     ApprovalSettings('international_signups_enabled'),
            //     handleGetUserAuthApproval(data.user.id)
            // ]);




            // if (userDetails && userDetails.oauth_provider === "custom_oauth") {
            //     const hasAccess = (isApproved === true || isApproved === "true") || userDetails.role === "admin";
            //     if (hasAccess) {

            //     } else {
            //         setError("You do not have international visitor access. Please request access.");
            //     }

            // } else {
            //     setError("You do not have admin access. Please request admin access.");
            // }



        } catch (err) {
            console.error('Login Failed:', err);
            setError(err.message || 'Invalid credentials.');

        } finally {
            setLoading(false);
        }
    };

    const handleResendVerification = async () => {
        setResendingVerification(true)
        setResendMessage(null)

        try {
            const response = await fetch(`${API_BASE_URL}/auth/resend-verification`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify({ email: formData.email })
            })

            const data = await response.json()

            if (response.ok) {
                setResendMessage('Verification email sent! Please check your inbox.')
                setShowResendVerification(false)
            } else {
                setResendMessage(data.message || 'Failed to resend verification email.')
            }
        } catch (error) {
            setResendMessage('An error occurred. Please try again.')
        } finally {
            setResendingVerification(false)
        }
    }

    return (
        <SplitBackgroundLayout>
            {loading && (
                <div className="absolute top-4 flex justify-center items-center w-full">
                    <LoadingSpinner meta={LoadingSpinnerMeta} />
                </div>
            )}

            {error && (
                <div className="w-full max-w-sm mb-4">
                    <div className="bg-danger-500/10 border border-danger-500 text-danger-500 px-6 py-4 rounded-lg">
                        <p className="font-bold text-lg mb-2">{meta.errorLabel}</p>
                        <p>{error}</p>
                        {showResendVerification && (
                            <button
                                onClick={handleResendVerification}
                                disabled={resendingVerification}
                                className="mt-3 w-full px-4 py-2 bg-primary-600 hover:bg-primary-700 disabled:opacity-50 disabled:cursor-not-allowed text-white rounded-lg transition-colors text-sm"
                            >
                                {resendingVerification ? meta.sending : meta.resendVerification}
                            </button>
                        )}
                    </div>
                </div>
            )}

            {resendMessage && (
                <div className="w-full max-w-sm mb-4">
                    <div className="bg-success-500/10 border border-success-500 text-success-500 px-6 py-4 rounded-lg">
                        <p>{resendMessage}</p>
                    </div>
                </div>
            )}

            <Card className="w-full max-w-sm shadow-lg p-4">

                        <h3 className="text-xl font-bold text-gray-900 dark:text-white text-center mb-0">
                            {meta.title}
                        </h3>

                        <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
                            {/* Email Input */}
                            <div>
                                <div className="mb-1 block">
                                    <Label htmlFor="email">{meta.emailLabel}</Label>
                                </div>
                                <TextInput
                                    id="email"
                                    type="email"
                                    name="email"
                                    placeholder={meta.emailPlaceholder}
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            {/* Password Input */}
                            <div>
                                <div className="mb-1 flex justify-between items-center">
                                    <Label htmlFor="password">{meta.passwordLabel}</Label>
                                    {/* Forgot Password Link */}
                                    <div className="text-sm font-medium text-gray-500 dark:text-gray-300 text-start italic">
                                        <Link to="/international/forgetpassword" className="text-cyan-700 hover:underline dark:text-cyan-500">
                                            {meta.forgotPassword}
                                        </Link>
                                    </div>
                                </div>
                                <TextInput
                                    id="password"
                                    type="password"
                                    name="password"
                                    placeholder={meta.passwordPlaceholder}
                                    value={formData.password}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            {/* Login Button */}
                            <Button type="submit">
                                {meta.loginButton}
                            </Button>

                            <Button type="button" variant="outline" onClick={() => {navigate('/international/signup')}}>
                                {meta.createAccount}
                            </Button>



                            <div>
                                <p className='text-gray-500 text-sm'>
                                    {meta.travelInfo}
                                </p>
                            </div>
                    </form>
                </Card>
        </SplitBackgroundLayout>
    );
}
export default LoginForm;

